import {Dialog, DialogContent} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React from 'react';
import {useGetToken} from '../../../../components/hooks';
import {i18n2} from '../../../../features/i18n/i18n';
import {print} from '../../../../helpers/functions';
import {TakeAssistance} from '../index';

interface ReportFromProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id_course: number;
  id_instance: number;
}

interface TakeAssistantFormProps {
  id_instance: number;
  id_course: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PrintReportForm = ({
  id_instance,
  id_course,
  open,
  setOpen,
}: ReportFromProps) => {
  const token = useGetToken();
  const printAssistantReport = `api/report?id=${id_instance}&id_course=${id_course}`;
  const printTest = `api/report/test?id=${id_course}`;

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogContent style={{padding: '10%'}}>
        <Button
          variant="contained"
          color="primary"
          style={{marginBottom: '6%'}}
          onClick={() =>
            print(printAssistantReport, id_course, token, 'Asistencia.pdf')
          }
        >
          {i18n2._('Imprimir reporte')}
        </Button>
        <br />
        <Button
          variant="contained"
          color="primary"
          onClick={() => print(printTest, id_course, token, 'Test.pdf')}
        >
          {i18n2._('Imprimir examen')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export const TakeAssistantForm = ({
  id_instance,
  id_course,
  open,
  setOpen,
}: TakeAssistantFormProps) => {
  //   const [update, setUpdate] = useState(false); //Para que es el update?
  const onClose = () => {
    setOpen(false);
  };
  return (
    <Dialog scroll="body" onClose={onClose} open={open}>
      <DialogContent>
        <TakeAssistance
          //   update={(x: any) => setUpdate(x)}
          id={id_instance}
          id_course={id_course}
          close={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
